import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext";
import { ContainerList, List, ListEmpty } from "./style";
import TechItem from "./TechItem";

export interface iTech {
  id: string;
  title: string;
  status: string;
}

const ListTechs = () => {
  const { techList } = useContext(UserContext);

  return (
    <ContainerList>
      {!techList.length ? (
        <ListEmpty>Você ainda não possui nenhuma tecnologia</ListEmpty>
      ) : (
        <List>
          {techList.map((tech: iTech) => (
            <TechItem key={tech.id} tech={tech} />
          ))}
        </List>
      )}
    </ContainerList>
  );
};
export default ListTechs;
